








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class RoomSearchInput extends Vue {
  @Prop() value?: string | null;
}
